/* eslint-disable react/prop-types */
import { CircularProgress, Typography } from "@mui/material"

import { useLoadingProgress } from "./hooks/useLoadingProgress"
import { LoadingOverlayRoot } from "./styled"

type LoadingOverlayProps = {
  disableOpacity?: boolean
  title?: React.ReactNode
  text?: React.ReactNode
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = (props) => {
  const { disableOpacity, title, text } = props
  const count = useLoadingProgress()

  return (
    <LoadingOverlayRoot disableOpacity={disableOpacity}>
      <CircularProgress value={count} />
      {title && (
        <Typography variant="h4Bold" mt={4}>
          {title}
        </Typography>
      )}
      {text && (
        <Typography variant="body2" textAlign="center" mt={2}>
          {text}
        </Typography>
      )}
    </LoadingOverlayRoot>
  )
}

export default LoadingOverlay
